import { createSelector } from 'reselect';
import { getFilterResults } from './getFilterResults';
import { getMembers } from 'find-and-filter-data/view-members-schema/protected';
const hasMemberContent = threadListMemberPageData => getMembers(threadListMemberPageData).size > 0;
export const isLoadingFilteredThreadListMembers = createSelector([getFilterResults], filterResults => {
  return filterResults.loading && !hasMemberContent(filterResults.data);
});